<template lang="pug">
  b-modal#addSEOPage(
  ref="addSEOPage"
  :title="$t('ui.combine.add_seo_page')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.row.mb-1
        div.col-sm-12.col-md-8.col-lg-8
          b-form-group(:label="$t('ui.page_name')").mb-0
            DebounceInput(
              size="sm"
              ref="page_name"
              type="text"
              :dirty="$v.page_name.$dirty"
              :error="$v.page_name.$error"
              v-model.trim.lazy="$v.page_name.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.page_name" :name="$t('ui.page_name')")
      div.row.mb-1
        div.col-sm-12.col-md-8.col-lg-8
          b-form-group(:label="$t('ui.domain_name')").mb-0
            b-form-textarea(
              style="height:80px;"
              :dirty="$v.domain_name.$dirty"
              :error="$v.domain_name.$error"
              v-model.trim.lazy="$v.domain_name.$model"
              :disabled="loading"
            )
        div.col-sm-12.col-md-4.col-lg-4
          span.small.text-info {{ $t("message.add_domain_remark") }}
          //- br
          //- span.small.text-info eg.
          br
          span.small.text-info abc.com
          br
          span.small.text-info 123.com
          br
          span.small.text-info xyz.com
          ValidateResult(:value="$v.domain_name" :name="$t('ui.domain_name')")
      div.row
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.meta_title')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_title"
              type="text"
              :dirty="$v.meta_title.$dirty"
              :error="$v.meta_title.$error"
              v-model.trim.lazy="$v.meta_title.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_title" :name="$t('ui.meta_title')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.meta_keywords')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_keywords"
              type="text"
              :dirty="$v.meta_keywords.$dirty"
              :error="$v.meta_keywords.$error"
              v-model.trim.lazy="$v.meta_keywords.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_keywords" :name="$t('ui.meta_keywords')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.meta_url')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_url"
              type="text"
              :dirty="$v.meta_url.$dirty"
              :error="$v.meta_url.$error"
              v-model.trim.lazy="$v.meta_url.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_url" :name="$t('ui.meta_url')")
      div.row
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.meta_canonical')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_canonical"
              type="text"
              :dirty="$v.meta_canonical.$dirty"
              :error="$v.meta_canonical.$error"
              v-model.trim.lazy="$v.meta_canonical.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_canonical" :name="$t('ui.meta_canonical')")
          b-form-group(:label="$t('ui.meta_lang')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_lang"
              type="text"
              :dirty="$v.meta_lang.$dirty"
              :error="$v.meta_lang.$error"
              v-model.trim.lazy="$v.meta_lang.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_lang" :name="$t('ui.meta_lang')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.meta_author')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_author"
              type="text"
              :dirty="$v.meta_author.$dirty"
              :error="$v.meta_author.$error"
              v-model.trim.lazy="$v.meta_author.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_author" :name="$t('ui.meta_author')")
          b-form-group(:label="$t('ui.meta_publisher')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_publisher"
              type="text"
              :dirty="$v.meta_publisher.$dirty"
              :error="$v.meta_publisher.$error"
              v-model.trim.lazy="$v.meta_publisher.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_publisher" :name="$t('ui.meta_publisher')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.meta_desc')")
            b-form-textarea(
              ref="meta_desc"
              :dirty="$v.meta_desc.$dirty"
              :error="$v.meta_desc.$error"
              v-model.trim.lazy="$v.meta_desc.$model"
              style="height:70px;"
            )
            ValidateResult(:value="$v.meta_desc" :name="$t('ui.meta_desc')")
      div.row.mb-3
        div.col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$t('ui.meta_image_url')").mb-0
            DebounceInput(
              size="sm"
              ref="meta_image_url"
              type="text"
              :dirty="$v.meta_image_url.$dirty"
              :error="$v.meta_image_url.$error"
              v-model.trim.lazy="$v.meta_image_url.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.meta_image_url" :name="$t('ui.meta_image_url')")
      b-tabs(small card)
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;").mr-1 {{ $t("ui.en") }}
            i.flag-icon.flag-icon-us
          div.d-flex.flex-wrap
            b-form-group.w-100(:label="$t('ui.item')").mb-0
              DebounceInput(
                size="sm"
                ref="en_item_name"
                type="text"
                :dirty="$v.en_item_name.$dirty"
                :error="$v.en_item_name.$error"
                v-model.trim.lazy="$v.en_item_name.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.en_item_name" :name="$t('ui.item')")
            b-form-group.w-100(:label="$t('ui.body')").mb-0
              ckeditor(
                v-model="en_body"
                :disabled="loading"
                :config="enBodyConfig"
              )
              //- ValidateResult(:value="$v.en_body" :name="$t('ui.en_body')")
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;").mr-1 {{ $t("ui.mys") }}
            i.flag-icon.flag-icon-my
          div.d-flex.flex-wrap
            b-form-group.w-100(:label="$t('ui.item')").mb-0
              DebounceInput(
                size="sm"
                ref="mys_item_name"
                type="text"
                :dirty="$v.mys_item_name.$dirty"
                :error="$v.mys_item_name.$error"
                v-model.trim.lazy="$v.mys_item_name.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.mys_item_name" :name="$t('ui.item')")
            b-form-group.w-100(:label="$t('ui.body')").mb-0
              ckeditor(
                v-model="mys_body"
                :disabled="loading"
                :config="mysBodyConfig"
              )
              //- ValidateResult(:value="$v.en_body" :name="$t('ui.en_body')")
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;").mr-1 {{ $t("ui.cn") }}
            i.flag-icon.flag-icon-cn
          div.d-flex.flex-wrap
            b-form-group.w-100(:label="$t('ui.item')").mb-0
              DebounceInput(
                size="sm"
                ref="cn_item_name"
                type="text"
                :dirty="$v.cn_item_name.$dirty"
                :error="$v.cn_item_name.$error"
                v-model.trim.lazy="$v.cn_item_name.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.cn_item_name" :name="$t('ui.item')")
            b-form-group.w-100(:label="$t('ui.body')").mb-0
              ckeditor(
                v-model="cn_body"
                :disabled="loading"
                :config="cnBodyConfig"
              )
              //- ValidateResult(:value="$v.en_body" :name="$t('ui.en_body')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import { VueEditor, Quill } from "vue2-editor";
import $ from 'jquery';
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1000000);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor
  },
  props: {
    // item: {
    //   type: Object
    // },
  },
  data() {
    return {
      meta_title: "",
      meta_desc: "",
      meta_keywords: "",
      meta_url: "",
      meta_canonical: "",
      meta_author: "",
      meta_publisher: "",
      meta_lang: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      page_name: "",
      domain_name: "",
      en_item_name: "",
      en_body: "",
      mys_item_name: "",
      mys_body: "",
      cn_item_name: "",
      cn_body: "",
      cnBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      mysBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      enBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      file: "",
      meta_image_url: "",
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  validations: {
    page_name: {
      required,
      maxLength: maxLength(255)
    },
    domain_name: {
      required,
    },
    en_item_name: {
      maxLength: maxLength(255)
    },
    mys_item_name: {
      maxLength: maxLength(255)
    },
    cn_item_name: {
      maxLength: maxLength(255)
    },
    meta_title: {
      maxLength: maxLength(255)
    },
    meta_desc: {
      maxLength: maxLength(500)
    },
    meta_keywords: {
      maxLength: maxLength(500)
    },
    meta_url: {
      maxLength: maxLength(500)
    },
    meta_canonical: {
      maxLength: maxLength(500)
    },
    meta_author: {
      maxLength: maxLength(255)
    },
    meta_publisher: {
      maxLength: maxLength(255)
    },
    meta_lang: {
      maxLength: maxLength(10)
    },
    meta_image_url: {
      maxLength: maxLength(500)
    }
  },
  watch: {
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.cmsSEOPageAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        audit_by: this.$store.getters.loginId,
        page_name: this.page_name,
        domain_name: this.domain_name,
        en_item_name: this.en_item_name,
        en_body: this.en_body,
        mys_item_name: this.mys_item_name,
        mys_body: this.mys_body,
        cn_item_name: this.cn_item_name,
        cn_body: this.cn_body,
        meta_title: this.meta_title,
        meta_desc: this.meta_desc,
        meta_keywords: this.meta_keywords,
        meta_url: this.meta_url,
        meta_canonical: this.meta_canonical,
        meta_author: this.meta_author,
        meta_publisher: this.meta_publisher,
        meta_lang: this.meta_lang,
        meta_image_url: this.meta_image_url
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addSEOPage.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_seo_page", this.feedback.status);
                this.$refs.addSEOPage.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    confirmSubmit() {
      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.page_name = "";
      this.domain_name = "";
      this.en_item_name = "";
      this.en_body = "";

      this.mys_item_name = "";
      this.mys_body = "";
      
      this.cn_item_name = "";
      this.cn_body = "";

      this.meta_title = "";
      this.meta_desc = "";
      this.meta_keywords = "";
      this.meta_url = "";
      this.meta_canonical = "";
      this.meta_author = "";
      this.meta_publisher = "";
      this.meta_lang = "";
      this.meta_image_url = "";
      $("#addSEOPage").find('.modal-content').first().removeAttr('tabindex');
    }
  }
};
</script>
